import { YearMonthPickerMonth } from './year-month-picker-month'
import { YearMonthPickerRoot } from './year-month-root'
import { useYearMonthPicker } from './use-year-month-picker'
import { YearMonthPickerPrev } from './year-month-prev'
import { YearMonthPickerNext } from './year-month-next'

export type { YearMonthPickerRootProps as HeadlessYearMonthPickerProps } from './year-month-root'

export const HeadlessYearMonthPicker = Object.assign(YearMonthPickerRoot, {
  Month: YearMonthPickerMonth,
  Prev: YearMonthPickerPrev,
  Next: YearMonthPickerNext,
  useYearMonthPicker: useYearMonthPicker
})
